/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";
import smoothscroll from "smoothscroll-polyfill";

/**
 * 再読み込み後ページ最上部へ
 */
window.onunload = function () {
  window.scrollTo(0, 0);
}


/**
 * 表示画面高さ取得
 */
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);

/**
 * クッキー同意
 */
const setCookieAccept = () => {
  let html = document.querySelector("html");
  let acceptBtn = document.querySelector(".--js-cookie-accept");
  acceptBtn.onclick = () => {
    document.cookie = "Cookie=true; max-age=" + 60 * 60 * 24 * 30;
    document.cookie && html.classList.add("--c-hidden");
    document.cookie && html.classList.remove("--c-show");
  }
  let checkCookie = document.cookie.indexOf("Cookie=true");
  checkCookie === -1 && html.classList.add("--c-show");
}

/**
 * Run.
 */
setFillHeight();
setCookieAccept();
modules();
smoothscroll.polyfill();

/**
 * Clear console.
 */
console.clear();